import { useEffect, useState } from "react";
import { useLang } from "@/i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const OVERLINE = { pt: "Saudação do dia", en: "Greeting of the day", es: "Saludo del día" };

export const MTAGreeting = () => {
  const { lang } = useLang();
  const [text, setText] = useState("");

  useEffect(() => {
    let active = true;
    fetch(`${API}/mta/greeting?lang=${lang}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (active && d?.text) setText(d.text); })
      .catch((e) => console.warn("MTA greeting failed", e));
    return () => { active = false; };
  }, [lang]);

  if (!text) return null;

  return (
    <section className="bg-[#FDFBF7] border-b border-[#E5E0D8]" data-testid="mta-greeting-banner">
      <div className="container-page py-5 flex items-center gap-4">
        <img
          src="/mta-avatar.jpg"
          alt="Mãe Três Vezes Admirável"
          className="h-12 w-12 rounded-full border-2 border-[#D4AF37] object-cover shrink-0"
        />
        <div>
          <div className="text-[10px] tracking-[0.24em] uppercase text-[#C9A640] font-semibold">
            {OVERLINE[lang] || OVERLINE.pt}
          </div>
          <p className="text-sm sm:text-base text-[#1A201F] italic leading-relaxed mt-0.5" data-testid="mta-greeting-text">
            {text}
          </p>
        </div>
      </div>
    </section>
  );
};

export default MTAGreeting;
